import { hasData } from "../../utils/utils";
import { parseBlogLanguageIds } from "../utils.reducer";
import {
  BLOG,
  getPostsByLanguage,
  getMultiLanguagePostMapping,
  fetchTag,
  fetchByCategory,
  fetchByCategoryAndId,
  fetchBySlug,
  getTagsFromBlog,
  NEWS_BLOG,
  COOKING_TIPS_BLOG,
  LOCAL_FOOD_BLOG,
} from "../utils.api";

const USE_BLOG_SLUG = process.env.REACT_APP_USE_BLOG_SLUG === "TRUE";
const FEATURE_BLOG = 856294;
const LIMIT = 50;

//get blog articles
const ALL_BLOGS = [
  BLOG,
  NEWS_BLOG,
  COOKING_TIPS_BLOG,
  LOCAL_FOOD_BLOG,
].toString();

export const blogApi = async () => {
  const data = await fetchByCategory(ALL_BLOGS, `per_page=${LIMIT}`);
  const dataNoTranslate = getPostsByLanguage(data);

  const postPairs = dataNoTranslate.map((post) => {
    const { id, slug, date, tags, categories } = post;

    if (USE_BLOG_SLUG) {
      const languageIds = parseBlogLanguageIds(post);
      const languagePosts = {};
      Object.entries(languageIds).forEach(([lang, langId]) => {
        const match = data.find((p) => p.id === langId);
        if (match) languagePosts[lang] = match;
      });
      return {
        id,
        slug,
        title: slug,
        categories,
        featureBlog: hasData(tags) && tags.includes(FEATURE_BLOG),
        date,
        vn: post,
        ...languagePosts,
      };
    }

    return {
      id,
      title: slug,
      categories,
      featureBlog: hasData(tags) && tags.includes(FEATURE_BLOG),
      date,
      vn: post,
      ...getMultiLanguagePostMapping(post, data, slug),
    };
  });

  return postPairs;
};

export const blogApiByID = async (blogId) => {
  const blog = await fetchByCategoryAndId(BLOG, blogId);

  let blogFullWidthTag;
  if (hasData(blog.tags)) {
    const allTags = await fetchTag();
    blogFullWidthTag = getTagsFromBlog(allTags, blog.tags, "blog-full-width");
  }

  const { id, date, slug, content, categories } = blog;
  return {
    id,
    date,
    title: slug,
    imageFullWidth: hasData(blogFullWidthTag) && Number(blogFullWidthTag[0]),
    categories,
    content,
  };
};

export const blogDetailBySlugApi = async (slug) => {
  const results = await fetchBySlug(slug, ALL_BLOGS);
  if (!results.length) return null;

  const blog = results[0];
  const languageIds = parseBlogLanguageIds(blog);

  let blogFullWidthTag;
  if (hasData(blog.tags)) {
    const allTags = await fetchTag();
    blogFullWidthTag = getTagsFromBlog(allTags, blog.tags, "blog-full-width");
  }

  const { id, date, slug: wpSlug, content, categories } = blog;
  return {
    id,
    date,
    slug: wpSlug,
    title: wpSlug,
    imageFullWidth: hasData(blogFullWidthTag) && Number(blogFullWidthTag[0]),
    categories,
    content,
    languageIds,
  };
};
